import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import styles from './suggest-domain.module.scss';

const domainList = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'aol.com',
  'icloud.com',
];

export type SuggestDomainProps = {
  prefix?: string;
  onSuggestionClick: (suggestion: string) => void;
  hasFieldDescription?: boolean;
};

export const SuggestDomain = ({
  prefix,
  onSuggestionClick,
  hasFieldDescription,
}: SuggestDomainProps) => {
  const [active, setActive] = useState<number>();
  const ref = useRef({ active, onSuggestionClick });
  ref.current = { active, onSuggestionClick };

  useEffect(() => {
    /* istanbul ignore if */
    if (typeof window === 'undefined') {
      return;
    }

    window.addEventListener('keydown', downHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
    };

    /* istanbul ignore next */
    function downHandler(event: KeyboardEvent) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          if (ref.current.active != null) {
            ref.current.onSuggestionClick(domainList[ref.current.active]);
          }
          break;
        case 'ArrowDown':
          setActive((a) => (a == null ? 0 : (a + 1) % domainList.length));
          break;
        case 'ArrowUp':
          setActive((a) =>
            a == null || a === 0 ? domainList.length - 1 : a - 1,
          );
      }
    }
  }, []);

  return (
    <div
      id="suggest-domain"
      className={classNames(
        styles.container,
        hasFieldDescription && styles.withDescription,
      )}
    >
      <div className={styles.border} />
      {domainList.map((domain, index) => {
        const onClick = () => onSuggestionClick(domain);
        return (
          <button
            className={classNames(
              styles.content,
              active === index && styles.activeContent,
            )}
            key={domain}
            onMouseEnter={() => setActive(index)}
            onTouchEnd={onClick}
            onMouseDown={(event) => event.preventDefault()}
            onClick={onClick}
          >
            <span className="fs-mask">
              {prefix?.slice(0, prefix.indexOf('@'))}@
            </span>
            {domain}
          </button>
        );
      })}
    </div>
  );
};
